import api from '../../api'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 媒体列表
    findCuList ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.findCuList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    // 获取ad的图片
    findSwiperList ({state, rootState}, opts) {
      return new Promise((resolve, reject) => {
        api.findSwiperList(opts).then(function (res) {
          if (res.body.success) {
            rootState.total = res.body.data.count
            resolve(res.body.data)
          }
        })
      })
    },
    findOperMtId ({state, rootState}, opts) {
      return new Promise((resolve, reject) => {
        api.findOperMtId(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    findOperMtName ({state, rootState}, opts) {
      return new Promise((resolve, reject) => {
        api.findOperMtName(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    // 帮助中心左边的数据
    findHelpLeftList ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.findHelpLeftList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    // 帮助中心id去获取根据数据
    getWconList ({commit, state, rootState}, opts) {
      return new Promise((resolve, reject) => {
        api.getWconList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data.rows)
            rootState.total = res.body.data.count
          }
        })
      })
    },
    // 文章id去获取根据数据
    getOperwconList ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.getOperwconList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    getZbxxclassList ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.getZbxxclassList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    getZbxxList ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.getZbxxList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    getAreaList ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.getAreaList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    getZbxxListById ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.getZbxxListById(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    getZbxxById ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.getZbxxById(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    // 文章列表list总数
    findOperWconCount ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.findOperWconCount(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    getIndexWconList ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.getIndexWconList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    getHomeClassifyList ({commit, state}, opts) {
      return new Promise((resolve, reject) => {
        api.getHomeClassifyList(opts).then(function (res) {
          if (res.body.success) {
            resolve(res.body.data)
          }
        })
      })
    },
    // 获取系统参数返回一个对象
    getSysparam ({dispatch, commit, state, rootState}) {
      return new Promise((resolve, reject) => {
        api.getSysparam().then(function (res) {
          if (res.body.success) {
            rootState.sysparam = res.body.data
            resolve(res.body.data)
          }
        })
      })
    },
    getOperpopflg ({dispatch, commit, state, rootState}) {
      return new Promise((resolve, reject) => {
        api.getOperpopflg().then(function (res) {
          if (res.body.success) {
            // rootState.sysparam = res.body.data
            resolve(res.body.data)
          }
        })
      })
    },
    updateZbxxClick ({dispatch, commit, state, rootState}, opts) {
      return new Promise((resolve, reject) => {
        api.updateZbxxClick(opts).then(function (res) {
          if (res.body.success) {
            // rootState.sysparam = res.body.data
            resolve(res.body.data)
          }
        })
      })
    },
    updateOperWconClick ({dispatch, commit, state, rootState}, opts) {
      return new Promise((resolve, reject) => {
        api.updateOperWconClick(opts).then(function (res) {
          if (res.body.success) {
            // rootState.sysparam = res.body.data
            resolve(res.body.data)
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/web.js